import {
  INotification,
  INotificationCreate,
  INotificationTable,
  IPagedData,
  IPagedSearch,
  TableStatus,
} from '@evencel/models';

export class GetNotification {
  public static readonly type = '[Notification] GetNotification';
  constructor(public id: string) {}
}

export class SearchNotifications {
  public static readonly type = '[Notification] SearchNotifications';
  constructor(public data: IPagedSearch) {}
}

export class CreateNotification {
  public static readonly type = '[Notification] SaveNotification';
  constructor(public notification: INotificationCreate) {}
}

export class UpdateNotification {
  public static readonly type = '[Notification] UpdateNotification';
  constructor(public notification: INotification) {}
}

export class DeleteNotification {
  public static readonly type = '[Notification] DeleteNotification';
  constructor(public notification: INotificationTable) {}
}

export class RestoreNotification {
  public static readonly type = '[Notification] RestoreNotification';
  constructor(public notification: INotificationTable) {}
}

export class GetNotificationsResponse {
  public static readonly type = '[Notification] GetNotificationsResponse';
  constructor(
    public pagedData: IPagedData<INotification>,
    public status: TableStatus
  ) {}
}

export class GetNotificationResponse {
  public static readonly type = '[Notification] GetNotificationResponse';
  constructor(public notification: INotification) {}
}
